import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, AlertTriangle } from "lucide-react";

export default function TagResolverPage() {
  const { tagId } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/field/tag/${encodeURIComponent(tagId)}`)
      .then((r) => {
        if (r.data.asset_id) navigate(`/asset/${encodeURIComponent(r.data.asset_id)}`, { replace: true });
        else setErr("This asset record is missing an identifier — contact your admin");
      })
      .catch((e) => setErr(e.response?.data?.detail || "Unknown asset tag"));
  }, [tagId, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6" data-testid="tag-resolver">
      {err ? (
        <div className="text-center max-w-sm" data-testid="tag-resolver-error">
          <AlertTriangle className="w-10 h-10 text-amber-500 mx-auto mb-3" />
          <div className="text-sm font-semibold text-slate-700">Asset tag {tagId}</div>
          <div className="text-xs text-rose-600 mt-1.5">{err}</div>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-sm text-slate-500">
          <Loader2 className="w-5 h-5 animate-spin" /> Opening asset {tagId}…
        </div>
      )}
    </div>
  );
}
